import { Modal } from "react-bootstrap";
function CfdFavoriteModal({ showModal, handleClose }) {
  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <li className="list-inline-item">
          <span className="flaticon-heart" />
          <b className="pl10">Save this listing</b>
        </li>
      </Modal.Header>
      <Modal.Body>
        <div className="spss">
          <form className="px-4 py-3">
            <p>
              Enter your e-mail to save this property to your favorites and to
              keep track of price and status changes.
            </p>
            <div className="mb-3 text-end tel-400">
              <input
                type="email"
                className="form-control mb-3"
                id="exampleDropdownFormEmail1"
                placeholder="email@example.com"
              />
              <button className="btn-thm" type="submit">
                Register
              </button>
              <p className="text-center mt10">
                Already have an account?{" "}
                <a className="text-thm" href="#">
                  Log In
                </a>
              </p>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CfdFavoriteModal;
